import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@domgen/dgx-fe-common';

declare global {
  interface Window {
    Genesys: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class LiveChatService {
  showMessenger = false;

  constructor(@Inject(WINDOW) private readonly window: Window) {}

  initialiseMessenger(): void {
    this.window.Genesys('subscribe', 'Messenger.ready', () => {
      this.showLauncher();
    });

    this.window.Genesys('subscribe', 'Messenger.closed', () => {
      this.showMessenger = false;
      this.showLauncher();
    });
  }

  showLauncher() {
    this.window.Genesys('command', 'Launcher.show');
  }

  openLiveChat(): void {
    if (!this.window.Genesys) return;

    this.showMessenger = true;
    this.window.Genesys('command', 'Launcher.hide');
    this.window.Genesys('command', 'Messenger.open');
  }
}
